import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'nominas/cuentas-contables-isn';

/**
 * GET Cuentas Contables ISN
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getCuentasContablesISN = async (params) => {
  try {
    const response = await API.get(`${baseURI}`, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Cuenta Contable ISN
 * @param {object} id
 * @returns {Promise<object|null>}
 */
export const getCuentaContableISN = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Cuenta Contable ISN
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postCuentaContableISN = async (values) => {
  try {
    const response = await API.post(`${baseURI}`, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Cuenta Contable
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchCuentaContableISN = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Cuenta Contable
 * @param {number} id
 * @return {Promise<boolean>}
 */
export const deleteCuentaContableISN = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
